import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { FAQS, SUPPORT_EMAIL } from '../../data/collection';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="preguntas" aria-labelledby="preguntas-title" className="w-full bg-ivory" data-id="element-190" data-mp="zrqc9e4zljia">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 [&>*]:min-w-0 px-5 py-16 sm:px-8 lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-16 lg:py-24" data-id="element-191" data-mp="usvtudaxlwyp">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-192" data-mp="23f4joilyw6p">
          <SectionHeading id="preguntas-title" title="Preguntas frecuentes" data-id="element-193" data-mp="gz4m9agrgn5m" />
          <p className="mt-4 text-[1.02rem] leading-relaxed text-graphite-soft" data-id="element-194" data-mp="gx1lpwhzfbmn">
            ¿Te quedó alguna duda? Escribinos a{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="break-all font-bold text-coral-ink underline decoration-coral/40 underline-offset-4 hover:decoration-coral-ink" data-id="element-195" data-mp="1sdrvtqpj0nlj">
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>

        <ul className="border-t border-ivory-line" data-id="element-196" data-mp="msk95k0z1h5q">
          {FAQS.map((faq, index) => {
          const expanded = open === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          return <li key={faq.question} className="border-b border-ivory-line" data-id="element-197" data-mp="vspbhfrb5pd1" data-mpi={index}>
                <h3 data-id="element-198" data-mp="3v9x73ssp39q5">
                  <button id={buttonId} type="button" aria-expanded={expanded} aria-controls={panelId} onClick={() => setOpen(expanded ? null : index)} className="flex min-h-[64px] w-full items-center justify-between gap-4 py-4 text-left text-[1.08rem] font-bold text-graphite transition-colors duration-150 ease-out hover:text-coral-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-coral/30 sm:text-[1.15rem]" data-id="element-199" data-mp="3v6j0u9gwugdf">
                    {faq.question}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${expanded ? 'rotate-45 bg-coral-deep text-white' : 'bg-blush text-coral-ink'}`} data-id="element-200" data-mp="iq637g8a2hxg">
                      <PlusIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden data-id="element-201" data-mp="4rg27pic7y3t" />
                    </span>
                  </button>
                </h3>
                <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-200 ease-out ${expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-202" data-mp="dr34semsz9yg">
                  <div className="overflow-hidden" hidden={!expanded} data-id="element-203" data-mp="1l5ekcrhbfxq8">
                    <p className="max-w-2xl pb-6 pr-10 text-[1.02rem] leading-relaxed text-graphite-soft" data-id="element-204" data-mp="1so5tze3yb02m">{faq.answer}</p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}